import icon from 'assets/icons/coins.svg';
import React, { Component, PureComponent } from 'react';
import { ResponsiveContainer, Tooltip, Treemap } from 'recharts';
import './EconomicProfit.style.scss';
import { get } from 'lodash';
import { nFormatter } from '../../../../utils';

export default class EconomicProfit extends Component {
  render() {
    // const data = get(this.props.data, 'segment', []);
    const data = [
      { segment_description: 'EP retail', economic_profit: 200 * 3125 },
      { segment_description: 'EP Wholesale', economic_profit: 190 * 3125 },
      { segment_description: 'EP Digital banking', economic_profit: 80 * 3125 },
      { segment_description: 'EP Treasury', economic_profit: 40 * 3125 },
    ];
    const COLORS = ['#A07E20', '#FBC83A', '#C89404', '#FDE39B'];
    return (
      <div className='EconomicProfitcontainer'>
        <h1 className='EconomicProfittitle'>
          <img src={icon} alt='' style={{ marginRight: 8 }} />
          ECONOMIC PROFIT
        </h1>
        <ResponsiveContainer width='100%' height={170}>
          <Treemap
            data={data}
            dataKey='economic_profit'
            content={<CustomizedContent colors={COLORS} />}>
            <Tooltip cursor={false} content={<CustomTooltip data={data} colors={COLORS} />} />
          </Treemap>
        </ResponsiveContainer>
      </div>
    );
  }
}
class CustomizedContent extends PureComponent {
  render() {
    const { x, y, width, height, index, colors, segment_description } = this.props;

    return (
      <g>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          style={{
            fill: colors[index % colors.length],
            stroke: '#fff',
            strokeWidth: 1,
          }}
          rx={4}
        />

        <text
          x={x + 8}
          y={y + height / 2 + 7}
          textAnchor='start'
          fill='#000000'
          fontSize={14}
          fontWeight={600}>
          {segment_description}
        </text>
      </g>
    );
  }
}

const CustomTooltip = (props) => {
  const { active, payload, data, colors } = props;

  if (active && payload && payload.length) {
    const item = payload[0].payload;
    const index = data.findIndex((el) => el.key === item.key);

    return (
      <div className='custom-tooltip' style={{ backgroundColor: colors[index % data.length] }}>
        <span className='name'>{item.segment_description}</span>
        <span className='desc'>{nFormatter(item.economic_profit)}</span>
      </div>
    );
  }

  return null;
};



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/EconomicProfit/EconomicProfit.js